<p-toast position="top-right"></p-toast>

<export-operators *ngIf="visibleExportOperators"
                  [visibleExportOperators]="visibleExportOperators"
                  (changedVisibleExportOperatorsEmit)="changedVisibleExportOperatorsEmit($event)"
                  (sendExportDtoEmit)="exportOperatorsEmit($event)"/>

<p-dialog [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="exportLoading"
          [style]="{ width: '425px', height: '215px' }">
    <ng-template pTemplate="header">
        <span class="dialog-header">Downloading data</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="dialog-txt text-small-normal" style="margin-top: -13px">Please wait while we preparing the data</div>
        <div class="mt-4 text-center">
            <p-progressSpinner styleClass="w-4rem h-4rem"
                               strokeWidth="8"
                               fill="var(--surface-ground)"
                               animationDuration=".5s" />
        </div>        
    </ng-template>
</p-dialog>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <div class="card">
        <p-table #operatorsGrid
                 [columns]="cols"
                 [value]="operators"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 selectionMode="single"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [showFirstLastIcon]="false"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [loading]="loading"
                 [style]="{height: 'calc(80vh)'}">
            <ng-template pTemplate="caption">
                <div class="onboarding-head">
                    <div class="onboarding-head-fleft ml-2">
                        <div class="head-title mt-3 ml-1">{{title}}</div>
                    </div>
                    <div class="flex flex-row onboarding-head-right mr-2">
                        <div>
                            <img class="btn-icon" src="Content/xpress-app/images/operator/signup/upload_files.svg" alt='' height="14" width="14">
                            <div pRipple class="btn-revenue-export" (click)="openExportOperators()">Export</div>
                        </div>

                        <div class="ml-4">
                            <column-selector #columnSelector
                                 [defaultColumns]="defaultCols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="title"
                                 [(selectedColumns)]="cols">
                            </column-selector>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="operatorHeaderSearch[filter.model]"
                                       (ngModelChange)="handleHeaderFilterChange($event)"/>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <input type="number" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="operatorHeaderSearch[filter.model]"
                                       (ngModelChange)="handleHeaderFilterChange($event)"/>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                            optionLabel="name" optionValue="value" [(ngModel)]="operatorHeaderSearch[filter.model]"
                                            (ngModelChange)="handleHeaderFilterChange($event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-operator>
                <tr [pSelectableRow]="operator">
                    <td *ngFor="let col of cols" class="ui-resizable-column">
                        {{operator[col.field]}}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="operators && operators.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + operators.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>

</div>
